let model = `# Blender v2.82 (sub 7) OBJ File: ''
# www.blender.org
mtllib self.mtl
o obj_0.002
v -1.546003 -4.934347 -4.757935
v -1.546003 -6.954547 -4.757935
v -1.546003 -4.934347 -4.757935
v 5.838398 6.043555 8.110262
v 5.627997 4.937455 7.746061
v 5.334798 6.043555 7.238264
v -5.838402 6.043553 -8.110136
v -5.291202 6.043553 -7.281736
v -4.053302 6.043553 -9.019938
v -2.940003 -4.935947 -4.046936
v 5.233998 -3.559747 1.701065
v 4.757998 -4.934346 1.546066
v 4.452998 -3.558046 3.235065
v 4.452598 -3.558547 3.235465
v 4.046998 -4.935946 2.940063
v 4.046597 -4.936445 2.940464
v 4.757998 -4.934346 1.546066
v 5.234097 -3.560046 1.700763
v 2.940297 -6.956046 4.046764
v 3.546597 -5.650745 4.141464
v -1.700702 -3.560045 5.234165
v -0.000002 -3.559046 5.504066
v -1.546003 -4.934345 4.758064
v -0.000002 -4.934546 5.003063
v 4.046698 -6.956046 2.940365
v 4.452698 -5.650745 3.235363
v -5.334802 6.043553 -7.238138
v -3.559203 6.043553 -8.164335
v -5.003003 -6.953847 0.000065
v -5.344802 -5.651947 1.003063
v -10.000002 6.043554 0.000063
v 4.452598 -3.558547 -3.235337
v 3.546597 -3.558548 -4.141335
v 4.046597 -4.936446 -2.940335
v 5.291198 6.043553 -7.281736
v 2.940397 -4.936447 -4.046535
v -1.701003 -5.652447 -5.233936
v -1.829403 -5.652247 -5.168636
v -1.701003 -3.559747 -5.233937
v -5.234103 -5.652846 1.700565
v -4.758003 -6.954746 1.545864
v 1.545797 -6.954745 4.758064
v 1.545998 -6.954546 4.758064
v 1.700498 -5.652845 5.234165
v -2.940003 -6.955746 4.047066
v -2.940003 -4.935946 4.047066
v -1.546003 -6.954546 4.758064
v 4.452998 -5.650446 3.235065
v -1.700702 -3.560047 -5.234036
v -0.000002 -6.953846 5.003063
v -9.841303 6.043554 1.003061
v 5.334798 6.043553 -7.238138
v 2.939997 -6.955746 4.047066
v 4.046998 -6.955746 2.940063
v 4.757998 -6.954546 1.546066
v -4.452602 -3.558547 -3.235337
v -4.046603 -4.936446 -2.940335
v -3.546603 -3.558548 -4.141335
v -5.234103 -5.652846 -1.700436
v -4.758003 -6.954746 -1.545734
v -5.344802 -5.651947 -1.002934
v -2.940403 -4.936447 -4.046535
v 1.829398 -5.652246 5.168766
v 1.700997 -5.652446 5.234066
v 3.546597 -3.558546 4.141464
v -1.701003 -5.652446 5.234066
v -1.700503 -5.652845 5.234165
v -1.701003 -3.559746 5.234066
v -9.841303 6.043554 -1.002936
v 4.046998 -6.955747 -2.939934
v -1.829403 -3.559546 5.168766
v -1.829403 -5.652246 5.168766
v -5.838402 6.043555 8.110262
v -5.334802 6.043555 7.238264
v -5.628003 4.937455 7.746061
v -3.546603 -5.650747 -4.141335
v -4.452702 -5.650746 -3.235234
v 4.452998 -5.650447 -3.234936
v 4.452698 -5.650746 -3.235234
v -4.453002 -5.650447 -3.234936
v -4.758003 -6.954547 -1.545937
v -4.047002 -6.955747 -2.939934
v -4.046702 -6.956047 -2.940235
v -2.940003 -6.955747 -4.046936
v -5.291202 6.043555 7.281862
v 1.545998 -4.934345 4.758064
v -5.344802 -3.559647 -1.002934
v -5.234103 -3.560046 -1.700634
v -5.234003 -5.652447 -1.700936
v -4.053302 6.043555 9.020063
v -3.559203 6.043555 8.164461
v 1.700698 -3.560045 5.234165
v -1.829403 -3.559547 -5.168637
v -1.545803 -6.954745 4.758064
v 3.559197 6.043553 -8.164335
v 1.829398 -3.559547 -5.168637
v 1.700997 -3.559747 -5.233937
v 1.545998 -4.934347 -4.757935
v -2.940303 -6.956048 -4.046635
v -5.628003 4.937453 -7.745935
v -4.047002 -4.935946 2.940063
v -4.758003 -4.934346 1.546066
v -4.452602 -3.558547 3.235465
v -5.234103 -3.560046 1.700763
v -4.758003 -4.934346 1.546066
v 2.939997 -4.935947 -4.046936
v 5.344798 -3.559646 1.003063
v -5.234003 -3.559747 1.701065
v -4.453002 -3.558046 3.235065
v -0.000002 -5.650745 5.504066
v 1.545998 -4.934347 -4.757935
v 1.700698 -3.560047 -5.234036
v -4.046603 -4.936445 2.940464
v -4.453002 -3.558047 -3.234936
v -4.758003 -4.934346 -1.545937
v 5.001997 -4.937246 0.000065
v 9.001597 6.043554 0.000063
v 8.842598 6.043554 1.003061
v -5.234003 -3.559747 -1.700936
v -4.047002 -4.935946 -2.939934
v -4.758003 -4.934346 -1.545937
v 3.559197 6.043555 8.164461
v 5.291198 6.043555 7.281862
v 1.829398 -3.559546 5.168766
v -4.758003 -6.954546 1.546066
v -5.003003 -4.934546 0.000065
v 4.053298 6.043555 9.020063
v -4.047002 -6.955746 2.940063
v 8.842598 6.043554 -1.002936
v 9.841297 6.043554 -1.002936
v 9.841297 6.043554 1.003061
v 9.999998 6.043554 0.000063
v 5.838398 6.043553 -8.110136
v 2.940297 -6.956048 -4.046635
v 2.939997 -6.955747 -4.046936
v 4.046698 -6.956047 -2.940235
v 3.546597 -5.650747 -4.141335
v 4.053298 6.043553 -9.019938
v 1.545998 -6.954547 -4.757935
v -8.842602 6.043554 1.003061
v -9.001602 6.043554 0.000063
v -8.842602 6.043554 -1.002936
v -4.453002 -5.650446 3.235065
v -5.344802 -3.559646 1.003063
v 5.627997 4.937453 -7.745935
v -5.234003 -5.652446 1.701065
v -2.940403 -4.936445 4.046665
v -3.546603 -3.558546 4.141464
v 1.829398 -5.652247 -5.168636
v 5.344798 -5.651947 1.003063
v 5.233998 -5.652446 1.701065
v 5.234097 -5.652846 1.700565
v -0.000002 -3.557347 -5.503937
v -0.000002 -4.935747 -5.001934
v 5.234097 -3.560046 -1.700634
v 4.757998 -4.934346 -1.545937
v 5.344798 -3.559647 -1.002934
v -0.000002 -6.956447 -5.001934
v -1.545803 -6.954747 -4.757935
v -1.700503 -5.652847 -5.234035
v 1.545797 -6.954747 -4.757935
v -0.000002 -5.650747 -5.503937
v 1.700498 -5.652847 -5.234035
v -2.940303 -6.956046 4.046764
v 4.757998 -6.954746 1.545864
v -3.546603 -5.650745 4.141464
v 1.700997 -3.559746 5.234066
v 1.545998 -4.934345 4.758064
v 2.939997 -4.935946 4.047066
v 1.700997 -5.652447 -5.233936
v -4.452702 -5.650745 3.235363
v -4.046702 -6.956046 2.940365
v 2.940397 -4.936445 4.046665
v -1.546003 -4.934345 4.758064
v 4.757998 -6.954746 -1.545734
v 4.757998 -6.954547 -1.545937
v 5.234097 -5.652846 -1.700436
v 5.233998 -5.652447 -1.700936
v 5.233998 -3.559747 -1.700936
v 4.452998 -3.558047 -3.234936
v 4.757998 -4.934346 -1.545937
v 4.046998 -4.935946 -2.939934
v 5.344798 -5.651947 -1.002934
v 5.001997 -6.956447 0.000065
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.796705 0.679488
vt 0.796705 0.707762
vt 0.774113 0.688038
vt 0.700456 0.687462
vt 0.724162 0.689900
vt 0.700911 0.735332
vt 0.892177 0.338591
vt 0.892182 0.386860
vt 0.854673 0.386821
vt 0.731449 0.220775
vt 0.723163 0.251746
vt 0.697726 0.224812
vt 0.697713 0.224825
vt 0.692491 0.255486
vt 0.692478 0.255499
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.073949 0.383677
vt 0.085224 0.668077
vt 0.073773 0.636871
vt 0.731454 0.220781
vt 0.003715 0.687876
vt 0.036829 0.691974
vt 0.012322 0.718852
vt 0.042428 0.722603
vt 0.048924 0.668101
vt 0.044044 0.636891
vt 0.724606 0.688495
vt 0.724606 0.736345
vt 0.396959 0.017349
vt 0.413955 0.044755
vt 0.338584 0.305750
vt 0.557975 0.586511
vt 0.587487 0.583587
vt 0.561669 0.620813
vt 0.597077 0.341051
vt 0.597702 0.617243
vt 0.387227 0.377882
vt 0.390684 0.377887
vt 0.387334 0.427178
vt 0.429844 0.043705
vt 0.432168 0.015045
vt 0.122747 0.668046
vt 0.122743 0.668041
vt 0.125267 0.636914
vt 0.735606 0.657953
vt 0.728594 0.610201
vt 0.767035 0.653350
vt 0.044029 0.586889
vt 0.044042 0.586901
vt 0.044034 0.636883
vt 0.387326 0.427171
vt 0.042428 0.770170
vt 0.361426 0.304268
vt 0.595657 0.341192
vt 0.656753 0.305031
vt 0.656763 0.305037
vt 0.692627 0.303073
vt 0.692636 0.303065
vt 0.723309 0.299334
vt 0.813493 0.419733
vt 0.818366 0.386833
vt 0.843219 0.419714
vt 0.358734 0.050627
vt 0.367527 0.021338
vt 0.372012 0.048838
vt 0.854660 0.386809
vt 0.121803 0.636900
vt 0.125255 0.636905
vt 0.073767 0.586881
vt 0.000000 0.000000
vt 0.843416 0.648963
vt 0.844846 0.648962
vt 0.195892 0.636982
vt 0.195882 0.636991
vt 0.195881 0.586987
vt 0.545475 0.098246
vt 0.545386 0.048975
vt 0.545480 0.098239
vt 0.319484 0.308351
vt 0.568639 0.667846
vt 0.542595 0.097931
vt 0.542507 0.048660
vt 0.780919 0.295426
vt 0.760860 0.290948
vt 0.780919 0.268871
vt 0.438752 0.426665
vt 0.438645 0.377380
vt 0.468121 0.425082
vt 0.468017 0.375797
vt 0.167423 0.046738
vt 0.167433 0.046730
vt 0.167437 0.096720
vt 0.468027 0.375804
vt 0.493303 0.339619
vt 0.462628 0.343267
vt 0.462618 0.343261
vt 0.854669 0.338562
vt 0.818349 0.338585
vt 0.818359 0.338578
vt 0.330950 0.738031
vt 0.306800 0.739064
vt 0.330506 0.736626
vt 0.078010 0.724609
vt 0.372100 0.098100
vt 0.358818 0.099900
vt 0.501761 0.371698
vt 0.501753 0.371709
vt 0.493306 0.339614
vt 0.307255 0.691194
vt 0.330950 0.690181
vt 0.075976 0.694209
vt 0.828077 0.726169
vt 0.845930 0.978401
vt 0.823763 0.970012
vt 0.012326 0.766446
vt 0.390791 0.427183
vt 0.636172 0.339725
vt 0.629356 0.581531
vt 0.632252 0.581438
vt 0.629186 0.616122
vt 0.426753 0.345194
vt 0.443158 0.643424
vt 0.009334 0.586980
vt 0.692557 0.615444
vt 0.655461 0.620802
vt 0.688886 0.582719
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.821526 0.679289
vt 0.821526 0.707185
vt 0.798962 0.687915
vt 0.597713 0.617230
vt 0.280261 0.440865
vt 0.266857 0.441154
vt 0.275306 0.406350
vt 0.648071 0.588693
vt 0.648077 0.588685
vt 0.688871 0.582709
vt 0.163820 0.586913
vt 0.163826 0.636891
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.692572 0.615454
vt 0.813480 0.419745
vt 0.786798 0.386928
vt 0.245598 0.406894
vt 0.261441 0.683166
vt 0.942642 0.690661
vt 0.942642 0.985015
vt 0.926918 0.937526
vt 0.280711 0.682766
vt 0.778785 0.419754
vt 0.818353 0.386845
vt 0.632259 0.581445
vt 0.946131 0.343394
vt 0.974806 0.346932
vt 0.968812 0.394836
vt 0.974809 0.346937
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.623006 0.014643
vt 0.669665 0.014603
vt 0.620385 0.227041
vt 0.778779 0.419747
vt 0.911499 0.339075
vt 0.905497 0.386978
vt 0.911494 0.339080
vt 0.940136 0.391272
vt 0.000000 0.000000
vt 0.357515 0.691214
vt 0.357071 0.692619
vt 0.333365 0.690181
vt 0.333819 0.738051
vt 0.357515 0.739064
vt 0.699569 0.663197
vt 0.662474 0.668564
vt 0.643512 0.735345
vt 0.647329 0.711380
vt 0.667485 0.735345
vt 0.643512 0.687415
vt 0.667485 0.687415
vt 0.671295 0.711380
vt 0.468134 0.425093
vt 0.501860 0.421005
vt 0.698041 0.735312
vt 0.673891 0.736345
vt 0.697597 0.733907
vt 0.604689 0.664281
vt 0.604698 0.664273
vt 0.568649 0.667852
vt 0.197243 0.046730
vt 0.698041 0.687462
vt 0.674346 0.688475
vt 0.085234 0.668070
vt 0.636172 0.663175
vt 0.854659 0.338555
vt 0.191346 0.686056
vt 0.187530 0.710021
vt 0.167373 0.686056
vt 0.191346 0.733986
vt 0.167373 0.733986
vt 0.163564 0.710021
vt 0.471227 0.092655
vt 0.429944 0.092984
vt 0.471139 0.043391
vt 0.786794 0.338659
vt 0.979332 0.673558
vt 0.999016 0.667066
vt 0.983161 0.914015
vt 0.889589 0.679233
vt 0.892271 0.946403
vt 0.873855 0.726706
vt 0.197243 0.096720
vt 0.414043 0.094017
vt 0.429936 0.092977
vt 0.429855 0.043713
vt 0.073965 0.357228
vt 0.121989 0.357228
vt 0.892271 0.974222
vt 0.872357 0.967709
vt 0.285231 0.364641
vt 0.303724 0.356625
vt 0.288830 0.608445
vt 0.443618 0.671160
vt 0.395527 0.671160
vt 0.157794 0.668048
vt 0.728582 0.610214
vt 0.718379 0.578427
vt 0.800650 0.929446
vt 0.818477 0.975399
vt 0.239501 0.096694
vt 0.239501 0.046692
vt 0.242423 0.096689
vt 0.069033 0.096692
vt 0.055994 0.096681
vt 0.069033 0.046700
vt 0.055988 0.046687
vt 0.055998 0.046677
vt 0.009340 0.636982
vt 0.009328 0.586987
vt 0.726577 0.345376
vt 0.727996 0.345169
vt 0.426743 0.345201
vt 0.158518 0.768916
vt 0.126457 0.768916
vt 0.149581 0.736093
vt 0.186939 0.668115
vt 0.120421 0.736001
vt 0.973693 0.428531
vt 0.960753 0.426935
vt 0.208815 0.439609
vt 0.210358 0.405208
vt 0.224720 0.440413
vt 0.120437 0.687720
vt 0.085402 0.687721
vt 0.085382 0.735995
vt 0.085398 0.687725
vt 0.545394 0.048967
vt 0.537207 0.019833
vt 0.500867 0.093993
vt 0.471240 0.092643
vt 0.389182 0.345232
vt 0.389178 0.345227
vt 0.387215 0.377872
vt 0.149593 0.687819
vt 0.149597 0.687824
vt 0.000000 0.000000
vt 0.238575 0.682025
vt 0.956206 0.657593
vt 0.597302 0.308351
vt 0.552049 0.279351
vt 0.974809 0.659902
vt 0.348068 0.375795
vt 0.315051 0.420993
vt 0.314949 0.371695
vt 0.557230 0.303911
vt 0.505893 0.016331
vt 0.505903 0.016339
vt 0.280707 0.359086
vt 0.280711 0.359091
vt 0.845930 0.679432
vt 0.778217 0.014068
vt 0.762368 0.060759
vt 0.353607 0.343249
vt 0.537209 0.019829
vt 0.738212 0.019507
vt 0.758827 0.014177
vt 0.742222 0.251292
vt 0.000000 0.000000
vt 0.348175 0.425107
vt 0.323486 0.339612
vt 0.616920 0.227055
vt 0.616928 0.227049
vt 0.619047 0.257449
vt 0.656608 0.257452
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.242423 0.046688
vt 0.242429 0.096682
vt 0.314939 0.371703
vt 0.303724 0.655459
vt 0.234502 0.015575
vt 0.202734 0.015548
vt 0.242431 0.046678
vt 0.234504 0.015571
vt 0.291702 0.326151
vt 0.246101 0.299724
vt 0.202724 0.015541
vt 0.251036 0.326153
vt 0.979324 0.628908
vt 0.983122 0.384738
vt 0.998849 0.637378
vt 0.998849 0.338003
vt 0.358724 0.050637
vt 0.501866 0.420997
vt 0.999016 0.961451
vt 0.471149 0.043384
vt 0.469713 0.014683
vt 0.500778 0.044734
vt 0.933733 0.654804
vt 0.919676 0.421837
vt 0.656621 0.257463
vt 0.012322 0.766441
vt 0.078006 0.772202
vt 0.000000 0.000000
vt 0.166325 0.015542
vt 0.763094 0.571957
vt 0.760021 0.605588
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.760195 0.572366
vt 0.767035 0.339488
vt 0.432173 0.015050
vt 0.904043 0.419888
vt 0.469703 0.014690
vt 0.763088 0.571950
vt 0.125257 0.586910
vt 0.901488 0.978736
vt 0.905315 0.738113
vt 0.921158 0.985270
vt 0.087894 0.768808
vt 0.125249 0.586903
vt 0.894708 0.419672
vt 0.894701 0.419680
vt 0.921158 0.690673
vt 0.128825 0.015573
vt 0.128830 0.015577
vt 0.126179 0.046680
vt 0.166315 0.015549
vt 0.000000 0.000000
vt 0.891248 0.419684
vt 0.699580 0.663202
vt 0.735597 0.657962
vt 0.126191 0.046690
vt 0.668345 0.226434
vt 0.517169 0.592841
vt 0.557960 0.586501
vt 0.524559 0.626489
vt 0.891440 0.648963
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.000000 0.000000
vt 0.517163 0.592850
vt 0.561654 0.620803
vt 0.167424 0.096732
vt 0.110428 0.046701
vt 0.055285 0.326153
vt 0.032642 0.326152
vt 0.671078 0.014526
vt 0.000000 0.000000
vt 0.093935 0.015531
vt 0.793652 0.979576
vt 0.775802 0.932850
vt 0.215768 0.357945
vt 0.215763 0.357949
vt 0.000000 0.000000
vt 0.251001 0.359659
vt 0.531545 0.673542
vt 0.923117 0.697092
vt 0.078010 0.772198
vt 0.013891 0.326151
vt 0.619193 0.305037
vt 0.126191 0.096691
vt 0.065029 0.015570
vt 0.758827 0.297725
vt 0.126183 0.096684
vt 0.110428 0.096693
vt 0.048914 0.668094
vt 0.848144 0.966051
vt 0.852447 0.725221
vt 0.870256 0.974584
vt 0.017359 0.668111
vt 0.009331 0.636991
vt 0.017357 0.668115
vt 0.870256 0.679250
vt 0.121797 0.586899
vn 0.0000 0.0000 1.0000
vn 0.8660 -0.0001 -0.5001
vn 0.0000 1.0000 0.0000
vn 0.4544 0.0000 0.8908
vn -0.8384 0.3385 -0.4272
vn -0.8422 0.3330 -0.4240
vn -0.8426 0.3379 -0.4195
vn 0.6610 -0.3550 0.6611
vn -0.7532 0.3252 -0.5718
vn 0.1473 0.3385 -0.9294
vn 0.6610 -0.3550 0.6610
vn -0.9234 -0.3550 0.1461
vn -0.6654 0.3385 0.6654
vn -0.4533 -0.0000 -0.8914
vn 0.3551 -0.3582 0.8635
vn 0.4544 0.0000 -0.8908
vn 0.7076 0.0000 0.7066
vn -0.3114 -0.0000 -0.9503
vn 0.1565 0.0000 -0.9877
vn -0.6653 0.3385 0.6654
vn -0.7085 0.0018 -0.7057
vn -0.7071 -0.0000 -0.7071
vn -0.7092 -0.0000 -0.7050
vn -0.7074 0.0000 -0.7068
vn -0.8908 0.0000 -0.4544
vn 0.6654 0.3385 0.6654
vn -0.9234 -0.3550 -0.1461
vn 0.4242 -0.3550 0.8331
vn 0.4459 -0.3536 0.8223
vn 0.7071 0.0000 0.7071
vn 0.6653 0.3385 0.6654
vn -0.1948 -0.0000 0.9808
vn -0.3140 0.0000 0.9494
vn -0.7071 0.0000 0.7071
vn -0.4533 0.0000 0.8914
vn -0.8660 -0.0001 -0.5001
vn 0.7044 -0.0000 -0.7098
vn -0.8139 -0.3796 -0.4399
vn -0.8329 -0.3550 -0.4245
vn -0.8154 -0.3565 -0.4561
vn 0.7074 0.0000 0.7068
vn 0.7081 -0.0000 0.7061
vn -0.1473 0.3385 -0.9294
vn -0.9876 0.0000 -0.1567
vn -0.8217 -0.3535 -0.4471
vn -0.8643 -0.3582 -0.3530
vn 0.8660 -0.0000 -0.5001
vn -0.1565 0.0000 -0.9877
vn -0.4272 0.3385 0.8384
vn -0.4270 0.3385 0.8385
vn -0.6610 -0.3550 -0.6611
vn 0.8912 0.0000 0.4537
vn 0.8384 0.3385 -0.4272
vn -0.6610 -0.3550 -0.6610
vn -0.8660 -0.0001 0.5001
vn -0.4202 0.3380 0.8421
vn -0.9294 0.3385 -0.1473
vn 0.7524 0.3248 -0.5731
vn 0.8418 0.3339 -0.4242
vn -0.1567 0.0000 0.9876
vn 0.8430 0.3379 -0.4186
vn 0.8418 0.3339 0.4242
vn 0.8660 0.0000 0.5001
vn 0.8384 0.3385 0.4272
vn 0.8429 0.3379 0.4188
vn -0.5740 0.3247 0.7517
vn 0.9877 0.0000 0.1565
vn 1.0000 0.0000 0.0000
vn -0.4272 0.3385 -0.8384
vn 0.7524 0.3248 0.5731
vn 0.9877 0.0000 -0.1565
vn 0.8908 0.0000 -0.4544
vn 0.7078 -0.0000 -0.7064
vn -0.8912 -0.0000 -0.4537
vn -0.7098 0.0000 0.7044
vn -0.7078 -0.0014 0.7064
vn -0.7076 0.0000 0.7066
vn -0.7072 0.0000 -0.7070
vn 0.7071 -0.0000 -0.7071
vn 0.4245 -0.3551 0.8329
vn -0.4544 0.0000 0.8908
vn 0.7078 0.0018 0.7064
vn 0.7078 0.0000 0.7064
vn -0.8912 0.0000 0.4537
vn 0.8908 0.0000 0.4544
vn 0.4596 -0.3567 0.8134
vn -0.9876 -0.0000 0.1567
vn -0.9490 0.0000 0.3152
vn 0.7052 -0.0015 0.7090
vn 0.4245 -0.3550 0.8329
vn 0.4246 -0.3550 0.8329
vn -0.7038 -0.0000 -0.7104
vn 0.8660 -0.0001 0.5001
vn -0.8660 -0.0000 -0.5001
vn -0.4245 -0.3550 -0.8329
vn 0.8660 -0.0000 0.5000
vn 0.1461 -0.3550 0.9234
vn 0.6654 0.3385 -0.6654
vn -0.8660 -0.0000 0.5000
vn -0.8660 0.0000 0.5001
vn 0.4533 -0.0000 -0.8914
vn 0.9876 -0.0000 0.1567
vn 0.9807 -0.0000 0.1955
vn 0.9495 0.0000 0.3139
vn 0.6653 0.3385 -0.6654
vn -0.4581 -0.3570 -0.8141
vn -0.1470 0.3385 0.9294
vn -0.1461 -0.3550 0.9234
vn 0.9294 0.3385 0.1473
vn -0.9294 0.3385 0.1473
vn 0.1559 0.0000 0.9878
vn 0.0694 0.0682 0.9953
vn -0.4457 -0.3536 0.8224
vn -0.7072 0.0000 0.7070
vn -0.4246 -0.3550 -0.8329
vn -0.4242 -0.3550 -0.8331
vn -0.3555 -0.3582 -0.8633
vn -0.1559 0.0000 0.9878
vn -0.0683 0.0683 0.9953
vn -0.4245 -0.3550 0.8329
vn -0.4458 -0.3536 -0.8223
vn 0.1568 -0.0000 -0.9876
vn -0.4596 -0.3567 0.8134
vn -0.9953 0.0689 -0.0679
vn -0.9878 0.0000 -0.1559
vn -0.1461 -0.3550 -0.9234
vn -0.4245 -0.3551 0.8329
vn -0.3560 -0.3582 0.8631
vn -0.4246 -0.3550 0.8329
vn 0.0000 -0.0000 -1.0000
vn -0.1792 0.0192 -0.9836
vn 0.1461 -0.3550 -0.9234
vn -0.5740 0.3247 -0.7517
vn 0.1567 -0.0000 -0.9876
vn 0.3118 -0.0000 -0.9501
vn 0.1949 -0.0000 -0.9808
vn -0.4242 -0.3550 0.8331
vn -0.9805 -0.0000 0.1964
vn 0.4245 -0.3550 -0.8329
vn 0.3557 -0.3582 -0.8633
vn 0.4573 -0.3572 -0.8144
vn 0.4246 -0.3550 -0.8329
vn -0.1568 -0.0000 -0.9876
vn -0.9805 -0.0000 -0.1965
vn -0.9490 -0.0000 -0.3152
vn 0.4242 -0.3550 -0.8331
vn 0.4459 -0.3536 -0.8223
vn -0.4270 0.3385 -0.8385
vn -0.6610 -0.3550 0.6610
vn 0.9294 0.3385 -0.1473
vn -0.4202 0.3382 -0.8420
vn 0.0047 0.0000 -1.0000
vn 0.6610 -0.3550 -0.6610
vn 0.4272 0.3385 -0.8384
vn -0.6610 -0.3550 0.6611
vn 0.4201 0.3379 -0.8422
vn -0.8642 -0.3585 0.3531
vn -0.8329 -0.3550 0.4245
vn -0.8215 -0.3537 0.4473
vn -0.8139 -0.3796 0.4399
vn -0.8146 -0.3570 0.4572
vn 0.5155 0.2448 -0.8212
vn 0.4269 0.3388 -0.8384
vn 0.1567 0.0000 0.9876
vn 0.1568 -0.0000 0.9876
vn -0.1568 -0.0000 0.9876
vn 0.1470 0.3385 0.9294
vn 0.4533 0.0000 0.8914
vn 0.6610 -0.3550 -0.6611
vn -0.1567 -0.0000 -0.9876
vn 0.3144 0.0000 0.9493
vn 0.5734 0.3248 0.7522
vn 0.8643 -0.3581 -0.3532
vn 0.8329 -0.3550 -0.4245
vn 0.4272 0.3385 0.8384
vn 0.7087 -0.0000 -0.7056
vn 0.7085 0.0018 -0.7057
vn 0.7074 0.0000 -0.7068
vn 0.8219 -0.3536 -0.4466
vn 0.4201 0.3379 0.8422
vn -0.6654 0.3385 -0.6654
vn 0.8146 -0.3782 -0.4397
vn 0.8159 -0.3564 -0.4553
vn -0.8384 0.3385 0.4272
vn 0.4270 0.3385 0.8385
vn -0.7532 0.3252 0.5718
vn -0.8427 0.3378 0.4193
vn -0.8422 0.3330 0.4240
vn 0.7076 -0.0000 -0.7066
vn -0.7048 -0.0023 0.7094
vn 0.9234 -0.3550 -0.1461
vn -0.6653 0.3385 -0.6654
vn -0.9953 0.0689 0.0676
vn -0.9878 0.0000 0.1559
vn 0.8660 -0.0000 -0.5000
vn -0.8908 0.0000 0.4544
vn -0.8660 -0.0000 -0.5000
vn -0.7075 0.0000 0.7067
vn -0.0047 0.0000 -1.0000
vn 0.9234 -0.3550 0.1461
vn -0.4544 0.0000 -0.8908
vn 0.8912 -0.0000 -0.4537
vn -0.7076 0.0000 -0.7066
vn 0.9495 0.0000 -0.3139
vn 0.9876 0.0000 -0.1567
vn 0.9822 0.0110 -0.1875
vn 0.8135 -0.3564 0.4595
vn 0.8329 -0.3550 0.4245
vn 0.8150 -0.3567 0.4567
vn 0.8643 -0.3581 0.3532
vn 0.8319 -0.3405 0.4381
vn 0.1949 -0.0000 0.9808
usemtl color_8273816.002
s off
f 1/1/1 2/2/1 3/3/1
f 4/4/2 5/5/2 6/6/2
f 7/7/3 8/8/3 9/9/3
f 2/10/4 1/11/4 10/12/4
f 11/13/5 12/14/5 13/15/5
f 14/16/6 13/15/6 12/14/6
f 14/16/7 15/17/7 16/18/7
f 15/17/5 14/16/5 12/14/5
f 17/19/1 12/20/1 18/21/1
f 5/22/8 19/23/8 20/24/8
f 18/25/9 12/14/9 11/13/9
f 21/26/10 22/27/10 23/28/10
f 24/29/10 23/28/10 22/27/10
f 19/23/11 25/30/11 20/24/11
f 26/31/11 20/24/11 25/30/11
f 27/32/3 8/8/3 7/7/3
f 28/33/3 9/9/3 8/8/3
f 29/34/12 30/35/12 31/36/12
f 32/37/13 33/38/13 34/39/13
f 35/40/13 36/41/13 33/38/13
f 37/42/14 38/43/14 39/44/14
f 40/45/12 30/35/12 41/46/12
f 42/47/15 43/48/15 44/49/15
f 45/50/16 46/51/16 47/52/16
f 34/39/13 33/38/13 36/41/13
f 13/53/17 14/54/17 48/55/17
f 39/44/18 49/56/18 37/42/18
f 29/34/12 41/46/12 30/35/12
f 24/29/19 50/57/19 23/28/19
f 30/35/12 51/58/12 31/36/12
f 33/38/20 52/59/20 35/40/20
f 53/60/21 16/18/21 19/61/21
f 25/62/22 19/61/22 16/18/22
f 54/63/23 25/62/23 16/18/23
f 15/17/24 54/63/24 16/18/24
f 54/63/25 15/17/25 55/64/25
f 12/14/25 55/64/25 15/17/25
f 56/65/26 57/66/26 58/67/26
f 59/68/27 60/69/27 61/70/27
f 57/66/26 62/71/26 58/67/26
f 63/72/28 64/73/28 43/48/28
f 44/49/29 43/48/29 64/73/29
f 20/24/30 26/31/30 65/74/30
f 60/69/27 29/34/27 61/70/27
f 55/75/1 12/20/1 17/19/1
f 27/76/31 58/67/31 8/77/31
f 66/78/32 67/79/32 21/80/32
f 68/81/33 66/82/33 21/83/33
f 69/84/27 61/70/27 31/36/27
f 62/71/26 8/77/26 58/67/26
f 29/34/27 31/36/27 61/70/27
f 36/41/34 70/85/34 34/39/34
f 71/86/35 72/87/35 68/81/35
f 66/82/35 68/81/35 72/87/35
f 73/88/36 74/89/36 75/90/36
f 58/91/22 76/92/22 56/93/22
f 76/92/22 77/94/22 56/93/22
f 78/95/37 79/96/37 32/97/37
f 80/98/38 77/94/38 81/99/38
f 82/100/39 81/99/39 77/94/39
f 83/101/40 82/100/40 77/94/40
f 10/12/4 84/102/4 2/10/4
f 10/12/41 62/71/41 84/102/41
f 82/103/42 83/104/42 57/66/42
f 74/105/3 73/106/3 85/107/3
f 24/29/43 22/27/43 86/108/43
f 87/109/44 88/110/44 61/70/44
f 59/111/45 89/112/45 81/99/45
f 59/111/46 81/99/46 60/113/46
f 73/106/3 90/114/3 85/107/3
f 91/115/3 85/107/3 90/114/3
f 92/116/43 86/108/43 22/27/43
f 80/98/39 81/99/39 89/112/39
f 93/117/47 9/118/47 28/119/47
f 50/57/19 94/120/19 23/28/19
f 93/121/14 39/44/14 38/43/14
f 86/108/48 50/57/48 24/29/48
f 95/122/49 96/123/49 35/40/49
f 96/123/50 97/124/50 98/125/50
f 99/126/51 76/92/51 100/127/51
f 13/53/52 48/55/52 11/128/52
f 101/129/53 102/130/53 103/131/53
f 99/126/54 83/101/54 76/92/54
f 104/132/1 102/133/1 105/134/1
f 7/135/55 100/136/55 27/137/55
f 36/41/56 35/40/56 106/138/56
f 98/125/49 106/138/49 96/123/49
f 35/40/49 96/123/49 106/138/49
f 18/139/57 107/140/57 17/141/57
f 104/142/58 108/143/58 102/130/58
f 109/144/59 103/131/59 102/130/59
f 22/145/60 21/80/60 110/146/60
f 111/147/1 98/148/1 112/149/1
f 113/150/61 101/129/61 103/131/61
f 109/144/53 102/130/53 108/143/53
f 114/151/62 115/152/62 56/65/62
f 116/153/57 107/140/57 117/154/57
f 90/155/63 72/156/63 71/157/63
f 118/158/57 117/154/57 107/140/57
f 116/153/57 17/141/57 107/140/57
f 114/151/64 119/159/64 115/152/64
f 56/65/65 120/160/65 57/66/65
f 77/94/54 76/92/54 83/101/54
f 112/161/66 98/125/66 97/124/66
f 29/162/67 60/163/67 121/164/67
f 81/165/68 121/164/68 60/163/68
f 120/160/64 56/65/64 115/152/64
f 121/166/1 115/167/1 88/168/1
f 122/169/69 123/170/69 124/171/69
f 88/172/70 115/152/70 119/159/70
f 41/173/68 105/174/68 125/175/68
f 126/176/71 105/174/71 29/162/71
f 102/133/1 125/177/1 105/134/1
f 6/178/3 123/179/3 4/180/3
f 4/180/3 123/179/3 127/181/3
f 123/179/3 122/182/3 127/181/3
f 128/183/72 125/184/72 101/129/72
f 129/185/3 117/186/3 130/187/3
f 118/188/3 131/189/3 117/186/3
f 132/190/3 117/186/3 131/189/3
f 113/150/73 128/183/73 101/129/73
f 114/191/74 80/98/74 119/192/74
f 130/187/3 117/186/3 132/190/3
f 52/193/3 133/194/3 35/195/3
f 134/196/75 36/41/75 135/197/75
f 70/85/76 36/41/76 136/198/76
f 106/138/77 135/197/77 36/41/77
f 114/191/78 56/93/78 80/98/78
f 137/199/79 32/97/79 79/96/79
f 95/200/3 35/195/3 138/201/3
f 133/194/3 138/201/3 35/195/3
f 63/72/80 43/48/80 53/202/80
f 98/125/81 139/203/81 106/138/81
f 62/71/30 57/66/30 84/102/30
f 99/204/82 84/102/82 57/66/82
f 120/160/83 82/103/83 57/66/83
f 140/205/3 141/206/3 51/207/3
f 142/208/3 69/209/3 141/206/3
f 69/209/3 31/210/3 141/206/3
f 51/207/3 141/206/3 31/210/3
f 109/211/84 108/212/84 143/213/84
f 82/103/85 120/160/85 81/214/85
f 140/215/1 51/216/1 144/217/1
f 137/218/63 145/219/63 33/220/63
f 19/23/86 5/22/86 53/202/86
f 33/221/79 32/97/79 137/199/79
f 144/222/87 30/35/87 104/223/87
f 108/212/88 104/223/88 146/224/88
f 30/35/87 40/45/87 104/223/87
f 48/55/89 65/74/89 26/31/89
f 4/225/90 127/226/90 5/22/90
f 63/72/91 53/202/91 5/22/91
f 5/22/90 127/226/90 63/72/90
f 80/98/92 56/93/92 77/94/92
f 133/227/93 52/228/93 145/219/93
f 95/229/94 138/230/94 96/231/94
f 7/232/95 9/233/95 100/127/95
f 33/220/96 145/219/96 52/228/96
f 42/47/97 44/49/97 50/234/97
f 147/235/98 113/150/98 148/236/98
f 27/137/99 100/136/99 58/237/99
f 103/131/98 148/236/98 113/150/98
f 110/146/97 50/234/97 44/49/97
f 76/238/100 58/237/100 100/136/100
f 96/239/101 149/240/101 97/241/101
f 107/242/102 18/243/102 150/244/102
f 151/245/103 152/246/103 18/243/103
f 11/128/104 151/247/104 18/248/104
f 74/249/105 85/250/105 148/236/105
f 48/55/52 151/247/52 11/128/52
f 100/127/106 84/251/106 99/126/106
f 112/252/107 153/253/107 111/254/107
f 147/235/98 148/236/98 85/250/98
f 94/255/108 50/234/108 67/79/108
f 50/234/108 110/146/108 67/79/108
f 154/256/107 111/254/107 153/253/107
f 88/257/109 87/258/109 121/164/109
f 155/259/110 156/260/110 157/261/110
f 157/261/110 156/260/110 116/153/110
f 158/262/111 154/256/111 159/263/111
f 3/264/111 2/265/111 154/256/111
f 2/265/112 159/263/112 154/256/112
f 67/266/113 66/82/113 47/267/113
f 136/198/34 36/41/34 134/196/34
f 38/43/95 100/127/95 9/233/95
f 143/213/34 148/268/34 103/269/34
f 109/211/114 143/213/114 103/269/114
f 135/197/81 106/138/81 139/203/81
f 116/153/110 117/154/110 157/261/110
f 146/224/84 143/213/84 108/212/84
f 100/127/115 38/43/115 84/251/115
f 2/270/95 84/251/95 38/43/95
f 38/43/116 37/42/116 2/270/116
f 159/271/117 2/270/117 160/272/117
f 154/256/118 158/262/118 161/273/118
f 154/256/119 161/273/119 139/274/119
f 98/148/1 111/147/1 139/275/1
f 154/256/118 139/274/118 111/254/118
f 129/276/110 157/261/110 117/154/110
f 29/162/71 105/174/71 41/173/71
f 126/176/109 87/258/109 141/277/109
f 102/130/72 101/129/72 125/184/72
f 90/278/120 75/279/120 72/87/120
f 142/280/109 141/277/109 87/258/109
f 126/176/109 121/164/109 87/258/109
f 147/235/79 45/50/79 113/150/79
f 160/272/121 2/270/121 37/42/121
f 162/281/122 112/282/122 163/283/122
f 99/204/30 57/66/30 83/104/30
f 115/152/85 81/214/85 120/160/85
f 73/284/120 75/279/120 90/278/120
f 164/285/123 45/286/123 75/279/123
f 165/287/124 55/288/124 116/153/124
f 55/288/125 17/141/125 116/153/125
f 9/118/47 93/117/47 38/289/47
f 166/290/94 75/90/94 148/291/94
f 158/292/126 159/271/126 162/281/126
f 160/272/126 162/281/126 159/271/126
f 45/286/127 47/267/127 72/87/127
f 67/266/128 47/267/128 94/293/128
f 45/286/129 72/87/129 75/279/129
f 129/294/130 130/295/130 157/296/130
f 115/167/1 121/166/1 81/297/1
f 37/42/131 153/298/131 160/272/131
f 158/292/132 162/281/132 161/299/132
f 163/283/132 161/299/132 162/281/132
f 126/176/67 29/162/67 121/164/67
f 92/300/133 167/301/133 168/302/133
f 169/303/69 168/302/69 124/171/69
f 92/304/1 168/305/1 86/306/1
f 162/281/134 153/298/134 112/282/134
f 97/241/135 170/307/135 112/308/135
f 170/309/136 163/283/136 112/282/136
f 72/87/137 47/267/137 66/82/137
f 96/231/94 138/230/94 149/310/94
f 146/224/138 104/223/138 40/45/138
f 97/241/101 149/240/101 170/307/101
f 139/311/139 149/240/139 135/312/139
f 163/313/140 139/311/140 161/314/140
f 169/303/69 124/171/69 123/170/69
f 138/315/139 145/316/139 149/240/139
f 134/317/141 135/312/141 145/316/141
f 135/312/142 149/240/142 145/316/142
f 133/318/139 145/316/139 138/315/139
f 162/281/143 160/272/143 153/298/143
f 142/319/130 87/320/130 69/321/130
f 61/322/130 69/321/130 87/320/130
f 61/70/44 88/110/44 59/68/44
f 89/323/144 59/68/144 88/110/144
f 119/192/145 89/112/145 88/324/145
f 149/240/146 139/311/146 170/307/146
f 163/313/147 170/307/147 139/311/147
f 30/325/1 144/217/1 51/216/1
f 89/112/74 119/192/74 80/98/74
f 124/171/148 168/302/148 167/301/148
f 171/326/149 172/327/149 166/328/149
f 166/328/149 172/327/149 164/285/149
f 140/329/150 144/330/150 141/277/150
f 173/331/151 169/303/151 123/170/151
f 47/332/152 23/28/152 94/120/152
f 126/176/150 144/330/150 105/174/150
f 86/108/48 42/333/48 50/57/48
f 168/305/1 43/334/1 86/306/1
f 79/96/153 136/335/153 137/199/153
f 134/317/153 137/199/153 136/335/153
f 46/51/154 21/336/154 174/337/154
f 23/338/1 174/339/1 21/340/1
f 46/51/154 85/250/154 71/341/154
f 166/328/155 164/285/155 75/279/155
f 147/235/156 85/250/156 46/51/156
f 91/342/154 71/341/154 85/250/154
f 41/46/157 125/343/157 40/45/157
f 104/344/150 105/174/150 144/330/150
f 141/277/150 144/330/150 126/176/150
f 128/345/158 171/326/158 125/343/158
f 40/45/159 125/343/159 146/224/159
f 146/224/158 125/343/158 143/213/158
f 171/326/160 143/213/160 125/343/160
f 171/326/161 128/345/161 172/327/161
f 21/336/162 46/51/162 68/346/162
f 71/341/163 68/346/163 46/51/163
f 92/347/164 22/145/164 110/146/164
f 110/146/165 44/49/165 92/347/165
f 110/146/166 21/80/166 67/79/166
f 118/348/1 107/349/1 131/350/1
f 154/256/167 153/253/167 3/264/167
f 49/351/167 3/264/167 153/253/167
f 64/73/168 63/72/168 167/352/168
f 134/317/169 145/316/169 137/199/169
f 150/244/102 18/243/102 152/246/102
f 153/298/170 37/42/170 49/56/170
f 167/352/171 92/347/171 64/73/171
f 49/353/172 39/354/172 1/11/172
f 150/355/1 131/350/1 107/349/1
f 175/356/173 176/357/173 177/358/173
f 70/359/174 79/96/174 176/357/174
f 3/3/1 49/360/1 1/1/1
f 1/11/175 93/361/175 10/12/175
f 128/183/176 113/150/176 172/362/176
f 164/363/177 113/150/177 45/50/177
f 164/363/79 172/362/79 113/150/79
f 46/51/178 45/50/178 147/235/178
f 177/358/179 176/357/179 178/364/179
f 62/71/180 10/12/180 8/77/180
f 14/16/181 16/18/181 65/365/181
f 166/328/34 148/268/34 171/326/34
f 178/364/174 176/357/174 78/95/174
f 78/95/182 176/357/182 79/96/182
f 79/96/183 70/359/183 136/335/183
f 179/366/184 180/367/184 181/368/184
f 10/12/175 93/361/175 8/77/175
f 173/331/181 65/365/181 16/18/181
f 93/361/185 1/11/185 39/354/185
f 28/369/175 8/77/175 93/361/175
f 181/370/1 156/371/1 155/372/1
f 174/337/16 47/52/16 46/51/16
f 155/373/186 179/366/186 181/368/186
f 182/374/184 181/368/184 32/37/184
f 34/39/187 182/374/187 32/37/187
f 173/331/181 123/170/181 65/365/181
f 32/37/188 181/368/188 180/367/188
f 180/375/189 78/95/189 32/97/189
f 143/213/190 171/326/190 148/268/190
f 183/376/191 130/377/191 132/378/191
f 6/379/192 65/365/192 123/170/192
f 47/380/1 174/339/1 23/338/1
f 132/378/191 184/381/191 183/376/191
f 5/5/47 20/382/47 65/383/47
f 175/384/193 116/153/193 176/385/193
f 181/370/1 176/386/1 156/371/1
f 156/260/194 176/385/194 116/153/194
f 184/387/194 116/153/194 175/384/194
f 184/381/191 175/356/191 183/376/191
f 6/6/195 5/5/195 65/383/195
f 181/368/196 182/374/196 176/388/196
f 70/85/196 176/388/196 182/374/196
f 74/89/197 148/291/197 75/90/197
f 177/358/191 183/376/191 175/356/191
f 70/85/198 182/374/198 34/39/198
f 48/55/30 14/54/30 65/74/30
f 91/389/63 90/155/63 71/157/63
f 116/153/125 184/387/125 165/287/125
f 42/333/199 86/108/199 43/390/199
f 131/391/200 150/244/200 132/378/200
f 168/302/201 169/303/201 43/392/201
f 53/60/201 43/392/201 169/303/201
f 180/375/202 179/393/202 78/95/202
f 152/246/200 165/394/200 150/244/200
f 169/303/203 173/331/203 53/60/203
f 16/18/22 53/60/22 173/331/22
f 165/394/200 184/381/200 150/244/200
f 184/381/200 132/378/200 150/244/200
f 183/395/130 157/296/130 130/295/130
f 179/393/204 155/396/204 178/364/204
f 183/376/205 177/358/205 157/397/205
f 177/358/206 178/364/206 157/397/206
f 26/31/207 54/398/207 48/55/207
f 151/247/208 48/55/208 54/398/208
f 25/30/209 54/398/209 26/31/209
f 122/399/100 124/400/100 127/401/100
f 178/364/202 78/95/202 179/393/202
f 55/402/208 152/403/208 54/398/208
f 165/404/210 152/403/210 55/402/210
f 151/247/211 54/398/211 152/403/211
f 178/364/205 155/396/205 157/397/205
f 124/400/100 63/405/100 127/401/100
f 124/406/168 167/352/168 63/72/168
f 64/73/212 92/347/212 44/49/212`; 

module.exports = model;